<template>
  <div class="site-wrapper">
    <Header></Header>
    <router-view />
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer"
export default {
  name: 'Layout',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
